import React, { useRef, useEffect } from "react";
import Lottie from "lottie-react";
import searchicon from "../../../assets/json/search.json"
import trashicon from "../../../assets/json/trash.json"
import editicon from "../../../assets/json/edit.json"
import viewicon from "../../../assets/json/view.json"
const icons = {
    searchIcon :searchicon,
      trashIcon: trashicon,
  editIcon: editicon,
  viewIcon: viewicon,
};

const LottieIcon = ({ name, size = 24, isActive = false, shouldPlay = false }) => {
  const lottieRef = useRef();
  const animationData = icons[name];
  
    useEffect(() => {
    if (shouldPlay) {
      lottieRef.current?.play();
    } else {
      lottieRef.current?.stop();
    }
  }, [shouldPlay]);


  if (!animationData) return null;

  return (
    <div style={{ width: size, height: size }}>
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop={false}
        autoplay={false}
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default LottieIcon;